import { ReactNode } from "react";
import Footer from "../../landing-page/components/Footer";

export default function MarketingPageLayout({ children }: { children: ReactNode }) {
  return (
    <div className="bg-background text-foreground">
      <main className="isolate">{children}</main>
      <Footer />
    </div>
  );
}
